import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { shopApi } from '../lib/api';
import type { PublicShopSummary } from '../lib/api';

export function Home() {
  const [shops, setShops] = useState<PublicShopSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    shopApi
      .listPublic()
      .then((res) => setShops(res.data))
      .catch((err) => setError((err as Error).message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <section className="hero">
        <h1>Les commerces rémois en ligne</h1>
        <p>Commandez chez vos commerçants indépendants de Reims, retirez en boutique.</p>
      </section>
      <main className="container">
        <h2>Boutiques ({shops.length})</h2>
        {error && <div className="alert alert-error">{error}</div>}
        {loading ? (
          <p>Chargement…</p>
        ) : shops.length === 0 ? (
          <p className="muted">Aucune boutique publiée pour le moment — revenez bientôt !</p>
        ) : (
          <div className="shop-grid">
            {shops.map((s) => (
              <Link to={`/boutiques/${s.slug}`} key={s.id}>
                <div className="shop-card">
                  <div className="cover" style={{ backgroundImage: s.cover_url ? `url(${s.cover_url})` : undefined }} />
                  <div className="body">
                    <h3>{s.name}</h3>
                    <div className="category">{s.shop_type.replace('_', ' ')}</div>
                    {s.address && <div className="address">{s.address}</div>}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
    </>
  );
}
